import {ApiIfDoneDTO, ApiOrderDTO} from "../services/GAIN/models";


export class TradeRequestModel implements ICommonOrderRqData {
    Type: string = ""; 
    Currency: string = "";   
    Quantity: number = 0; 
    Side: string = ""; 
    StopPrice: number = 0; 
    LimitPrice: number = 0; 
    StopPips: number = 0; 
    LimitPips: number = 0; 
    Id:string = "";
    AccountId:any;
    Provider?:string;
    AccountID?:string;
    EnterPrice:number = 0;
    TrailingStopPips?:number
    StopOrderId?:number;
    LimitOrderId?:number;


    public static TYPE_PENDING: string = "Pending";
    public static TYPE_MARKET: string = "Market";

}

export interface ICommonOrderRqData
{
    Type: string; 
    Currency: string;   
    Quantity: number; 
    Side: string; 
    StopPrice: number; 
    LimitPrice: number; 
    StopPips: number; 
    LimitPips: number; 
    Id:string;
    EnterPrice?:number;
    TrailingStopPips?:number
    StopOrderId?:number;
    LimitOrderId?:number;

}


export class EditRq implements ICommonOrderRqData
{
    Type: string = ""; 
    Currency: string = "";   
    Quantity: number = 0; 
    Side: string = ""; 
    StopPrice: number = 0; 
    LimitPrice: number = 0; 
    StopPips: number = 0; 
    LimitPips: number = 0; 
    Id:string = "";
    EnterPrice?:number;
    TrailingStopPips?:number
    StopOrderId?:number;
    LimitOrderId?:number;

    public SetSLOrderIds(order:ApiOrderDTO):void
    {
        if( order.IfDone && order.IfDone.length>0)                                                
        {
            let ifDone:ApiIfDoneDTO = order.IfDone[0];
            if(ifDone.Limit)
            {
                this.LimitOrderId = ifDone.Limit.OrderId?ifDone.Limit.OrderId:0;
            }
            if(ifDone.Stop)
            {
                this.LimitOrderId = ifDone.Stop.OrderId?ifDone.Stop.OrderId:0;
            }

        }
        if( order.AssociatedOrders)                                                
        {
            if(order.AssociatedOrders.Limit)
            {
                this.LimitOrderId = order.AssociatedOrders.Limit.OrderId?order.AssociatedOrders.Limit.OrderId:0;
            }
            if(order.AssociatedOrders.Stop)
            {
                this.StopOrderId = order.AssociatedOrders.Stop.OrderId?order.AssociatedOrders.Stop.OrderId:0;
            }

        }

    }

}

export class PartialCloseRq
{
    Ticket: string = ""; 
    CloseQty:number = 0;
}